const PostTypes = {
    TEXT : 0,
    MEDIA : 1,
    LINK : 2,
    OG : 3,
    YOUTUBE : 4,
    GIF_LINK : 5,
}


const AttachmentType = { 
    IMAGE : 1,
    VIDEO : 2,
    AUDIO : 3,
    YOUTUBE : 4,
    GIF_IMAGE : 5,
    GIF_LINK : 6,


}

const SpaceFlags = {
    FAKE: 2,
}

// These enums below are to match the backend
const BannerPagesIDs = {
    POSTS: 2
}

const BannersNumbers = {
    GROWTH_FUND: 1
}
export {PostTypes, AttachmentType, SpaceFlags, BannerPagesIDs, BannersNumbers} 
